module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "review"
  }, [_c('Picture', {
    staticClass: "review__image",
    attrs: {
      "src": _vm.src,
      "alt": _vm.title
    }
  }), _c('router-link', {
    staticClass: "review__link",
    attrs: {
      "to": _vm.link
    }
  }, [_c('h1', {
    staticClass: "review__title"
  }, [_vm._v(_vm._s(_vm.title))])]), _c('p', {
    staticClass: "review__text"
  }, [_vm._v(_vm._s(_vm.text))]), _c('Stars', {
    attrs: {
      "rating": _vm.rating
    }
  }), _c('p', {
    staticClass: "review__date"
  }, [_vm._v("Вы оставили отзыв " + _vm._s(_vm.date))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3eb4619c","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/blocks/cards/review/Review.vue
// module id = eebbd16a9f66148ed2a7
// module chunks = 89